<template>
    <header id="header" class="h-20 hidden md:block text-base shrink-0">
        <nav :class="navClass">
            <div class="px-12 flex flex-row flex-nowrap justify-between items-center space-x-5">
                <NuxtLink class="py-5 h-20 leading-10" :href="localePath('/')">
                    <EnhancedImage
                        css-class="brand-logo"
                        :src="logoUrl"
                        :lazy-load="false"
                        alt="TrustedParts.com"
                        multi-resolution
                        height="40"
                        width="275" />
                </NuxtLink>

                <form class="py-2 grow" role="search" :action="localePath('/search')" @submit.prevent>
                    <HeaderSearchBox
                        :placeholder="$t('Layout.SearchPartNumberDefaultText')"
                        :language="locale"
                        :region="currentRegion?.ShortName"
                        :is-home="false" />
                </form>

                <!-- Normal Filters -->
                <div class="hidden xl:flex justify-evenly items-center space-x-5">
                    <HeaderLanguageMenu />
                    <HeaderCurrenciesMenu />
                    <HeaderRegionsMenu />
                </div>

                <!-- Mini Filters -->
                <div class="block xl:hidden">
                    <HeaderFiltersMenu />
                </div>

                <HeaderAccountMenu />
            </div>
        </nav>
    </header>
</template>
<script setup lang="ts">
const { locale } = useI18n();
const localePath = useLocalePath();
const config = useRuntimeConfig();
const cdnUrl = config.public.cdnUrl;
const logoUrl = cdnUrl + "/assets/images/trusted-parts-logo.svg";

const props = defineProps<{ notSticky?: boolean }>();

const currentRegion = useCurrentRegion();

const navClass = computed(() => ["bg-accent min-h-20 mb-5", props.notSticky ? "" : "top-0 fixed inset-x-0 z-30"]);
</script>
